import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

// import required modules
import { Navigation } from "swiper";
import { testimonials } from "../data/data";

const Testimonials = () => {
  return (
    <div className="overflow-hidden py-32 bg-slate-100">
      <div className="container mx-auto px-5">
        <Swiper navigation={true} modules={[Navigation]} className="mySwiper">
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div class="flex flex-col items-center justify-center gap-8 bg-slate-100">
                <h3 class="text-4xl text-gray-600 leading-relaxed text-center w-4/5">
                  {item.feedback}
                </h3>
                <div class="flex items-center gap-4">
                  <div class="rounded-full w-12 h-12 overflow-hidden">
                    <img src={item.img} alt="img" />
                  </div>
                  <div class="flex flex-col tracking-wider">
                    <label class="text-gray-600 font-bold text-base">
                      {item.name}
                    </label>
                    <label class="text-gray-400 font-normal text-sm">
                      {item.title}
                    </label>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Testimonials;
